export default "/_next/static/data/customers-are-split-lottie.json-bf83915923de5eb61ab121bd7e943440.json";